/**
 * StatTile — a label, a value, and a meter.
 *
 * ── THERE IS NO `delta` PROP, AND THAT IS THE POINT ─────────────────────────
 *
 * The spec's data slide draws "72 +9 pts" and "18 3 critical". The second is a
 * breakdown of the same number and is real. **The first is a change since a
 * previous audit, and nothing in this product tracks that** — it needs two
 * audits of the same target with the earlier scores retained, which does not
 * exist. It is exception 2 in DECISIONS.md, it was removed from the homepage
 * mockup this week, and the way to stop it coming back is for the component to
 * have nowhere to put it.
 *
 * A prop that is accepted and ignored is worse than one that does not exist:
 * the caller writes `delta="+9"`, sees nothing, and files a bug. `note` exists
 * for the legitimate case ("3 critical") and is deliberately not called
 * `delta`.
 */
export function StatTile({ label, value, note, noteTone = 'neutral', meter, meterColor, testId }) {
  const pct = meter == null ? null : Math.max(0, Math.min(100, Number(meter) || 0));
  const noteColor = noteTone === 'critical' ? 'var(--danger)' : 'var(--ink-2)';

  return (
    <div className="uxa-stat-tile" data-testid={testId || 'stat-tile'}>
      <p className="uxa-stat-tile__label">{label}</p>
      <p className="uxa-stat-tile__value">
        {value}
        {note ? <span className="uxa-stat-tile__note" style={{ color: noteColor }}>{note}</span> : null}
      </p>
      {pct == null ? null : (
        <div className="uxa-stat-tile__meter" aria-hidden="true">
          <div style={{ width: `${pct}%`, background: meterColor || 'var(--accent)' }} />
        </div>
      )}
    </div>
  );
}

export default StatTile;
